import { useState, type FormEvent } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { Button, Card, Field, Notice } from '@ailab/ui';
import { adminUserSchema, cursorPageSchema } from '@ailab/contracts';
import { apiRequest, errorMessage } from '../../lib/http';
import styles from '../account/account.module.css';

// Listado de usuarios para administración (RF-08.02). Email enmascarado (RF-08.17).

const usersPage = cursorPageSchema(adminUserSchema);
const when = new Intl.DateTimeFormat('es-ES', { dateStyle: 'medium' });

export function AdminUsersPage() {
  const [draft, setDraft] = useState('');
  const [query, setQuery] = useState('');
  const users = useInfiniteQuery({
    queryKey: ['admin', 'users', query],
    queryFn: ({ pageParam }) => {
      const params = new URLSearchParams({ limit: '25' });
      if (query) params.set('q', query);
      if (pageParam) params.set('cursor', pageParam);
      return apiRequest(`/admin/users?${params.toString()}`, usersPage);
    },
    initialPageParam: '',
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
  const items = users.data?.pages.flatMap((page) => page.items) ?? [];

  function search(event: FormEvent) {
    event.preventDefault();
    setQuery(draft.trim());
  }

  return (
    <div className={styles.sections}>
      <h1>Usuarios</h1>
      <Card>
        <form className={styles.form} onSubmit={search}>
          <Field
            label="Buscar por email, nombre o nombre de Skool"
            value={draft}
            maxLength={100}
            onChange={(event) => setDraft(event.target.value)}
          />
          <Button type="submit" variant="secondary">
            Buscar
          </Button>
        </form>
      </Card>
      <Card>
        {users.isPending ? <p role="status">Cargando usuarios…</p> : null}
        {users.isError ? <Notice tone="error">{errorMessage(users.error)}</Notice> : null}
        {users.isSuccess && items.length === 0 ? <p>No hay usuarios con esa búsqueda.</p> : null}
        <ul className={styles.sessionList}>
          {items.map((user) => (
            <li key={user.id} className={styles.session}>
              <div>
                <Link
                  className={styles.inlineLink}
                  to="/admin/usuarios/$userId"
                  params={{ userId: user.id }}
                >
                  {user.firstName} {user.lastName}
                </Link>
                <div className={styles.sessionMeta}>
                  {user.emailMasked} · {user.skoolName} · alta el{' '}
                  {when.format(new Date(user.createdAt))}
                </div>
              </div>
              {user.status === 'disabled' ? (
                <span className={styles.badge}>Desactivada</span>
              ) : null}
            </li>
          ))}
        </ul>
        {users.hasNextPage ? (
          <Button type="button" variant="ghost" onClick={() => void users.fetchNextPage()}>
            Ver más
          </Button>
        ) : null}
      </Card>
    </div>
  );
}
